import { render } from "./socialMediaIcons.vue?vue&type=template&id=31f80aca"
import script from "./socialMediaIcons.vue?vue&type=script&lang=js"
export * from "./socialMediaIcons.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__